import { useEffect, useRef } from 'react';

/**
 * Runs `fn` every `ms` while the tab is visible (a hidden tab skips the beats, and catches up once when shown
 * again). For a value that changes with time alone and has no live message: a reader turning "Tidak merespons".
 */
export function useInterval(ms: number, fn: () => void, enabled = true) {
  const saved = useRef(fn);
  saved.current = fn;
  useEffect(() => {
    if (!enabled) return;
    let missed = false;
    const beat = () => {
      if (document.hidden) missed = true;
      else saved.current();
    };
    const shown = () => {
      if (!document.hidden && missed) {
        missed = false;
        saved.current();
      }
    };
    const t = window.setInterval(beat, ms);
    document.addEventListener('visibilitychange', shown);
    return () => {
      window.clearInterval(t);
      document.removeEventListener('visibilitychange', shown);
    };
  }, [ms, enabled]);
}
